module.exports = __webpack_public_path__ + "static/media/email.5888e84d.svg";